export const ImpersonateTypes = {
  SET_IMPERSONATE: 'SET_IMPERSONATE',
  CLEAR_IMPERSONATE: 'CLEAR_IMPERSONATE',
};

export const setImpersonate = (data: {
  name: string;
  id: string;
  originalOrganizationId?: string;
  originalOrganizationName?: string;
}) => ({
  type: ImpersonateTypes.SET_IMPERSONATE,
  data: data,
});

export const clearImpersonate = () => ({
  type: ImpersonateTypes.CLEAR_IMPERSONATE,
  data: '',
});

export type ImpersonateState = {
  impersonateName: string;
  impersonateId: string;
  isImpersonating: boolean;
  originalOrganizationId: string;
  originalOrganizationName: string;
};

export type ImpersonateAction = {
  type: string;
  data: {
    id: string;
    name: string;
    originalOrganizationId?: string;
    originalOrganizationName?: string;
  };
};

const impersonateReducer = (
  state: ImpersonateState = {
    impersonateName: '',
    impersonateId: '',
    isImpersonating: false,
    originalOrganizationId: '',
    originalOrganizationName: '',
  },
  action: ImpersonateAction,
) => {
  switch (action.type) {
    case ImpersonateTypes.SET_IMPERSONATE:
      return {
        ...state,
        impersonateName: action.data.name,
        impersonateId: action.data.id,
        isImpersonating: true,
        originalOrganizationId: action.data.originalOrganizationId || state.originalOrganizationId,
        originalOrganizationName: action.data.originalOrganizationName || state.originalOrganizationName,
      };

    case ImpersonateTypes.CLEAR_IMPERSONATE:
      return {
        ...state,
        impersonateName: '',
        impersonateId: '',
        isImpersonating: false,
        originalOrganizationId: '',
        originalOrganizationName: '',
      };

    default:
      return state;
  }
};

export default impersonateReducer;
